import { encodeRefNum } from "./refNumCrypto";

/**
 * Where a row's case details live.
 *
 * The ref number is obfuscated in the URL exactly as the case list does it —
 * same helper, so a link from here and a click from the list land on the same
 * page. `basePath` is passed in rather than derived, because the analytics page
 * is mounted under two prefixes and a link should keep the reader in the design
 * they are already looking at.
 *
 * Returns null for a row with no usable reference, so the table can leave the
 * link out instead of rendering one that goes nowhere.
 */
export const caseHrefFor = (refNum, basePath = "/cases") => {
  if (typeof refNum !== "string") return null;
  const trimmed = refNum.trim();
  if (!trimmed || trimmed === "—") return null;
  return `${basePath}/${encodeRefNum(trimmed)}`;
};

/**
 * Appends the list row's country as ?country=. The detail payloads do not
 * reliably carry one, rows open in a new tab (so no router state), and the
 * list already knows it. Unknown/placeholder countries add nothing.
 */
export const withCountryParam = (href, country) => {
  const value = typeof country === "string" ? country.trim() : "";
  if (!href || !value || value.toLowerCase() === "unknown") return href;
  return `${href}?country=${encodeURIComponent(value)}`;
};

/** The ?country= a list row passed, or "" when there is none. */
export const countryFromSearch = (search) =>
  new URLSearchParams(search || "").get("country") || "";
